import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountInfoComponent, LoginSignupComponent, ReservationsComponent } from '@unleashed/account/components';

const routes: Routes = [
  { path: 'login', component: LoginSignupComponent },
  { path: 'info', component: AccountInfoComponent },
  { path: 'reservations', component: ReservationsComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule {
}
